export default "__VITE_ASSET__c1066488__"